import { Box } from '@mui/material';
import React from 'react';

import DimoLogo from 'assets/icons/dimo-logo.svg';
import SupportIcon from 'assets/icons/headset-icon.svg';
import MotoIcon from 'assets/icons/moto-icon.svg';

import { ActionButton, HeaderBar, HeaderContent, LogoContainer, LogoMark, LogoWordmark, WhatsLink } from './styles';

export const Header: React.FC = () => {
  return (
    <HeaderBar>
      <HeaderContent>
        <Box component="a" href="/" aria-label="Dimo">
          <LogoContainer>
            <LogoMark src={MotoIcon} alt="Logotipo Dimo" loading="lazy" />
            <LogoWordmark src={DimoLogo} alt="Dimo" loading="lazy" />
          </LogoContainer>
        </Box>

        <ActionButton type="button" aria-label="Central de suporte">
          <WhatsLink  href="https://wa.me/551151968374" target="_blank">
            <img src={SupportIcon} alt="Suporte" loading="lazy" />
          </WhatsLink>
        </ActionButton>
      </HeaderContent>
    </HeaderBar>
  );
};
